<script>
import { markRaw } from 'vue';

import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import MixinList from '@/Libs/Mixins/List.js';

import FilterFormSidebar from './Part/FilterFormSidebar.vue';

export default {
    mixins: [MixinList],
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            filterFormSidebar: markRaw(FilterFormSidebar),

            routeName: 'stuff-available',
        }
    },
    methods: {
        async _search() {
            return await this.$api.StuffAvailable.all(this.search);
        },
        // ======
        load() {
            if (!this.$route) return;

            this.search = { ...this.$route.query };

            this.$orderBy.reset(this.search);

            if (Object.keys(this.$route.query).length > 0) {
                this._doSearch();
            }
        },
        redirectButton(data) {
            var vm = this;
            if (data.is_available == 0 && (vm.$ac.hasAccess('reservation_full_access') || vm.$ac.hasAccess('reservation_show'))) {
                vm.$router.push({ name: 'reservation-detail', params: { id: data.reservation_id } });
                return;
            }

            if (data.is_available == 1 && (vm.$ac.hasAccess('reservation_full_access') || vm.$ac.hasAccess('reservation_create'))) {
                vm.$router.push({
                    name: 'reservation-create', query: {
                        store_id: data.store_id,
                        branch_id: data.branch_id,
                        room_id: data.room_id,
                        stuff_id: data.stuff_id,
                        booked_date: data.date,
                        booked_time: data.sign_in,
                        session_id: data.session_id,
                    }
                });
                return;
            }

            return false;
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="$t('stuff_available.title.list')" :pageTitle="$t('menu.sub_header.dashboard')" />

        <BRow class="g-4 align-items-center mb-3">
            <BCol sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                    <btn-sidebar variant="primary"
                        v-if="($ac.hasAccess('stuff_available_full_access') || ($ac.hasAccess('stuff_available_list')))"
                        :sidebar="filterFormSidebar" :success="onSubmitFilter">
                        <i class="mdi mdi-magnify align-bottom me-1"></i> {{ $t('branch_session.btn.search') }}
                    </btn-sidebar>
                </div>
            </BCol>
        </BRow>

        <BRow>
            <BCol lg="12">
                <BCard no-body>
                    <BCardBody>
                        <div>
                            <div class="table-responsive table-card position-relative">
                                <loading :loading="$loading.get([routeName, 'list'].join('_'))" variant="dark"
                                    type="block">
                                    <table class="table align-middle table-hover table-nowrap mb-0">
                                        <thead class="table-light">
                                            <tr>
                                                <th style="width: 10px;">{{ $t('basic.label.line') }}</th>
                                                <th>{{ $t('stuff_available.label.date') }}</th>
                                                <th>{{ $t('stuff_available.label.store') }}</th>
                                                <th>{{ $t('stuff_available.label.branch') }}</th>
                                                <th>{{ $t('stuff_available.label.room') }}</th>
                                                <th>{{ $t('stuff_available.label.stuff') }}</th>
                                                <th>{{ $t('stuff_available.label.signin') }}</th>
                                                <th>{{ $t('stuff_available.label.signout') }}</th>
                                                <th>{{ $t('stuff_available.label.reservation') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(tr, index) in list" :key="index" class="cursor-pointer" :class="{
                                                'bg-success-subtle': tr.is_available == 1,
                                                'bg-danger-subtle': tr.is_available == 0
                                            }" @click="redirectButton(tr)">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ tr.date }}</td>
                                                <td>
                                                    {{ tr.store }}
                                                    <br><span class="text-body-secondary">{{ tr.store_ref_no }}</span>
                                                </td>
                                                <td>
                                                    {{ tr.branch }}
                                                    <br><span class="text-body-secondary">{{ tr.branch_ref_no }}</span>
                                                </td>
                                                <td>
                                                    {{ tr.room }}
                                                    <br><span class="text-body-secondary">{{ tr.room_ref_no }}</span>
                                                </td>
                                                <td>
                                                    {{ tr.stuff_number }}<span v-if="tr.stuff_ref_no_external"> | {{
                                                        tr.stuff_ref_no_external }}</span>
                                                    <br><span class="text-body-secondary">{{ tr.stuff_ref_no }}</span>
                                                </td>
                                                <td>{{ tr.sign_in }}</td>
                                                <td>{{ tr.sign_out }}</td>
                                                <td>
                                                    <BBadge variant="danger" v-if="tr.is_available == 0">{{
                                                        $t('stuff_available.label.reserved') }}</BBadge>
                                                    <BBadge variant="success" v-if="tr.is_available == 1">{{
                                                        $t('stuff_available.label.available') }}</BBadge>
                                                    <div v-if="tr.is_available == 0">
                                                        <span class="text-body-secondary">{{ tr.reservation_ref_no
                                                            }}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </loading>
                            </div>
                        </div>
                    </BCardBody>
                </BCard>
            </BCol>
        </BRow>
        <BRow class="mb-3">
            <BCol>
                <div>
                    <pagination v-bind:model="paginator" v-on:goto="goto"
                        :disabled="$loading.get([routeName, 'list'].join('_'))" />
                </div>
            </BCol>
        </BRow>
    </Layout>
</template>